<ng-container *ngIf="isLoadingReleases; then loading else content"></ng-container>

<ng-template #loading>
  <h2 class="panel-title-dummy">
    <div class="shine"></div>
  </h2>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>

  <h2 class="panel-title-dummy">
    <div class="shine"></div>
  </h2>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
</ng-template>

<ng-template #content>
  <h2 class="panel-title">{{ 'Modules.RemoteDeviceUpdateComponent.LatestVersion' | translate }}</h2>

  <form *ngIf="!hasCrossPointRole()" class="form-container" [formGroup]="selectFirmwareFormGroup">
    <app-input type="options" formControlName="firmware" [basicOptions]="firmwareNames"
      label="{{ 'Modules.RemoteDeviceUpdateComponent.LatestVersion' | translate }}"
      optionsInfo="{{ 'Modules.RemoteDeviceUpdateComponent.LatestVersion' | translate }}"></app-input>
  </form>

  <form *ngIf="hasCrossPointRole()" class="form-container" [formGroup]="selectFirmwareFormGroup">
    <app-input type="options" formControlName="firmware" [basicOptions]="firmwareNames"
      label="{{ 'Modules.RemoteDeviceUpdateComponent.SelectedFirmware' | translate }}"
      optionsInfo="{{ 'Modules.RemoteDeviceUpdateComponent.SelectedFirmware' | translate }}"></app-input>
  </form>

  <div class="action-buttons">
    <button mat-flat-button class="button small-button" (click)="installFirmware(true)"
      [disabled]="hasAnySelected() || hasCrossPointRole()">
      <mat-icon>update</mat-icon>
      <p>{{ 'Modules.RemoteDeviceUpdateComponent.UpdateToSelectedVersion' | translate }}</p>
    </button>
  </div>

  <h2 class="panel-title">{{ 'Modules.RemoteDeviceUpdateComponent.UpdateSpecificStores' | translate }}</h2>
  <div class="action-buttons">
    <button mat-flat-button class="button small-button" (click)="installFirmware(false)" [disabled]="!hasAnySelected()">
      <mat-icon>update</mat-icon>
      <p>{{ 'Modules.RemoteDeviceUpdateComponent.StartUpdate' | translate }}</p>
    </button>
  </div>

  <app-search-bar [title]="'Modules.RemoteMaintenance.Filter' | translate"
    [placeholder]="'Modules.RemoteMaintenance.FilterInfo' | translate"
    (onSearchTextChanged)="onSearchTextChanged($event)">
  </app-search-bar>

  <div class="panel">
    <ng-container *ngFor="let xpac of filteredUpgradeDevices">
      <app-list-item [selectable]="true" (onClickCallback)="onXpacClicked(xpac)" [selected]="isSelected(xpac)"
        [title]="getTitleString(xpac)" [info]="getInfoString(xpac)" [info2]="getInfoStringFirmware(xpac)">
      </app-list-item>
    </ng-container>
  </div>

  <div class="panel-no-data" *ngIf="!filteredUpgradeDevices.length && !isLoadingFilteredDevices">
    {{ (searchText.length > 0 ? 'Modules.RemoteMaintenance.NoStoresFiltered' : 'Modules.RemoteMaintenance.NoStores')
    | translate: { filter: searchText } }}
  </div>

  <div *ngIf="isLoadingFilteredDevices">
    <mat-spinner class="spinner" diameter="28"></mat-spinner>
  </div>

</ng-template>
